import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireModule, requirePermission } from '../../../../app/guards'

/** Maintenance contracts (Service C2): an opt-in module; every page below needs it and contracts.read. */
export const Route = createFileRoute('/_app/service/contracts')({
  staticData: { crumb: 'serviceContracts' },
  beforeLoad: ({ context }) => {
    requireModule(context.session, 'contracts')
    requirePermission(context.session, 'contracts.read')
  },
  component: Outlet,
})
